import { render } from "./lang-dialog-view.vue?vue&type=template&id=05871cd6&scoped=true&ts=true"
import script from "./lang-dialog-view.vue?vue&type=script&lang=ts"
export * from "./lang-dialog-view.vue?vue&type=script&lang=ts"

import "./lang-dialog-view.vue?vue&type=style&index=0&id=05871cd6&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05871cd6"]])

export default __exports__